/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscalesituationdevelopmentweak4Inputs */



/**
* | output |
* | --- |
* | "Predicting how an emotional situation will unfold can be hard for you — analysing its causes and possible consequences will help you understand its dynamics." |
*
* @param {Eisubscalesituationdevelopmentweak4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscalesituationdevelopmentweak4 = /** @type {((inputs?: Eisubscalesituationdevelopmentweak4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscalesituationdevelopmentweak4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Predicting how an emotional situation will unfold can be hard for you — analysing its causes and possible consequences will help you understand its dynamics.")
	if (locale === "es") return /** @type {LocalizedString} */ ("A veces te cuesta prever cómo se desarrollará una situación emocional — analizar sus causas y posibles consecuencias te ayudará a entender su dinámica.")
	return /** @type {LocalizedString} */ ("Тебе бывает сложно предсказать, как будет развиваться эмоциональная ситуация — анализ причин и возможных последствий поможет лучше понимать её динамику.")
});
export { eisubscalesituationdevelopmentweak4 as "eiSubscaleSituationDevelopmentWeak" }